import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */
export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Innovation Stats',
      type: 'report-card',
      content: {
        '[]': [
          {
            '{}': {
              name: 'Ideas',
              values: {
                '[]': [
                  {
                    '{}': {
                      name: 'Active Ideas',
                      value: {
                        '{}': {
                          aside: '',
                          emphasis: {
                            '-': [
                              {
                                '#': {
                                  '@': 'ideas',
                                },
                              },
                              {
                                '#': {
                                  '@': 'completedIdeas',
                                },
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Completed Ideas',
                      value: {
                        '{}': {
                          aside: 'Goal of 70',
                          emphasis: {
                            '#': {
                              '@': 'completedIdeas',
                            },
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Completion Rate',
                      value: {
                        '{}': {
                          aside: '',
                          emphasis: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '#': {
                                        '@': 'ideas',
                                      },
                                    },
                                    0,
                                  ],
                                },
                                '0%',
                              ],
                              {
                                'fmt.num': [
                                  {
                                    '/': [
                                      {
                                        '#': {
                                          '@': 'completedIdeas',
                                        },
                                      },
                                      {
                                        '#': {
                                          '@': 'ideas',
                                        },
                                      },
                                    ],
                                  },
                                  '%',
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                ],
              },
            },
          },
          {
            '{}': {
              name: 'Assets',
              values: {
                '[]': [
                  {
                    '{}': {
                      name: 'All Assets',
                      value: {
                        '{}': {
                          aside: '',
                          emphasis: {
                            '#': {
                              '@': 'assets',
                            },
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'AI Enabled Assets',
                      value: {
                        '{}': {
                          aside: '',
                          emphasis: {
                            '#': {
                              '@': 'aiEnabledAssets',
                            },
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'AI Enabled Percent',
                      value: {
                        '{}': {
                          aside: '',
                          emphasis: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '#': {
                                        '@': 'assets',
                                      },
                                    },
                                    0,
                                  ],
                                },
                                '0%',
                              ],
                              {
                                'fmt.num': [
                                  {
                                    '/': [
                                      {
                                        '#': {
                                          '@': 'aiEnabledAssets',
                                        },
                                      },
                                      {
                                        '#': {
                                          '@': 'assets',
                                        },
                                      },
                                    ],
                                  },
                                  '%',
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Average SWAG Impact',
                      value: {
                        '{}': {
                          aside: '',
                          emphasis: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '#': {
                                        '@': 'swagImpact',
                                      },
                                    },
                                    0,
                                  ],
                                },
                                0,
                              ],
                              {
                                '/': [
                                  {
                                    '+': {
                                      '@': 'swagImpact',
                                    },
                                  },
                                  {
                                    '#': {
                                      '@': 'swagImpact',
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                ],
              },
            },
          },
        ],
      },
    },
  },
  subqueries: {
    ideas: {
      target: 'ent:!innovation_ideas:!innovation_idea',
      selection: {
        '@.': '!id',
      },
    },
    assets: {
      target: 'ent:!innovation_assets:!innovation_asset',
      selection: {
        '@.': '!id',
      },
    },
    swagImpact: {
      filter: {
        '!=': [
          {
            '@.': '!swag_impact',
          },
          null,
        ],
      },
      target: 'ent:!innovation_assets:!innovation_asset',
      selection: {
        '@.': '!swag_impact',
      },
    },
    completedIdeas: {
      filter: {
        '=': [
          {
            '@.': '!status',
          },
          'Package & Release',
        ],
      },
      target: 'ent:!innovation_ideas:!innovation_idea',
      selection: {
        '@.': '!id',
      },
    },
    aiEnabledAssets: {
      filter: {
        '=': [
          {
            '@.': '!ai_enabled',
          },
          true,
        ],
      },
      target: 'ent:!innovation_assets:!innovation_asset',
      selection: {
        '@.': '!id',
      },
    },
  },
}
